// extracted by mini-css-extract-plugin
module.exports = {"editor":"editor_editor__17xbM","showEditor":"editor_showEditor__2wj8G","monacoEditor":"editor_monacoEditor__3Wqc2"};